import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ReportPhishingCard from './report_phishing/ReportPhishingCard'
import EmailDetailsCard from './email_details/EmailDetailsCard'
import EmailRoutingPathCard from './email_routing_path/EmailRoutingPathCard'
import UrlScanCard from './url_scan/UrlScanCard'
import StickyFooter from './common/StickyFooter'
import Card from 'react-bootstrap/Card';
import {logUserProfile, logEmailInfo} from '../../helpers/logging'
import {getEmailLoggingInfo, getUserProfile} from '../../helpers/mailbox'
import {getShowAnalysisPreference, setShowAnalysisPreference} from '../../helpers/local_storage'
import Form from 'react-bootstrap/Form'

export default function App(props) {
  const { isOfficeInitialized } = props;
  const [showMoreAnalysis, setShowMoreAnalysis] = useState(getShowAnalysisPreference() || false);

  useEffect(() => {
    if (isOfficeInitialized) {
      // Call one-time app-start processes here
      // Log User and Email Information
      // logUserProfile(getUserProfile());
      // logEmailInfo(getEmailLoggingInfo());
    }
  }, [isOfficeInitialized]);


  useEffect(() => {
    if(getShowAnalysisPreference() !== showMoreAnalysis){
      // Keep the local storage value in sync with the state value
      setShowAnalysisPreference(showMoreAnalysis);
    }
  }, [showMoreAnalysis]);


  if (!isOfficeInitialized) {
    return (
      <Container fluid as="main">
      <Row>
        <Col>
          <section id="sideload-msg" >
            <h5>Please sideload your add-in to see app body.</h5>
          </section>
        </Col>
      </Row>
    </Container>
    );
  }

  return (
    <>
      <Container fluid as="main">
        <Row>
          <div className="px-4 py-2 mb-2 ms-bgColor-neutralLighter w-100">
            <small className="font-weight-bold">Developed by <a href="https://www.dtonomy.com/demo-video/" target="_blank" rel="noreferrer">DTonomy Inc.</a></small>
          </div>
        </Row>
        <Row>
          <Col>
            <Card className="w-100 mb-2" style={{padding: "0 1.25rem", userSelect: "none"}}>
              <Card.Body className="px-0 py-2 font-weight-bold">
                <Form.Check 
                  type="switch"
                  id="showMoreAnalysisSwitch"
                  label={"Show Analysis"}
                  checked={showMoreAnalysis}
                  onChange={()=> setShowMoreAnalysis(!showMoreAnalysis)}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <ReportPhishingCard/>
          </Col>
        </Row>
        <div className={showMoreAnalysis ? "" : "d-none"}>
          <Row>
            <Col>
              <EmailDetailsCard/>
            </Col>
          </Row>
          <Row>
            <Col>
              <EmailRoutingPathCard />
            </Col>
          </Row>
          <Row>
            <Col>
              <UrlScanCard/>
            </Col>
          </Row> 
        </div>
        <Row>
          <Col>
            <Card className="w-100 mb-3 border-0">
              <Card.Body className="px-0 font-weight-bold">
                Visit <a href='https://www.dtonomy.com/tips-and-techniques-for-investigating-suspected-phishing-emails/' target='_blank'>DTonomy</a> for tips on investigating phishing emails. Join our <a href='https://dtonomy.slack.com/join/shared_invite/zt-dpvdz946-NgEYwW~aUhwTosER6SiK~w#/' target='_blank'>Slack</a> for any questions you may have.
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <StickyFooter>
        <div className="text-center">
            <a href="mailto:support@dtonomy.com" className="btn help_btn" role="button">HELP</a>
        </div>
      </StickyFooter>
    </>
  );
}